import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sticker-message d-inline-block" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }

import {useMessageTypeProps} from "~/chat/vue/widget/tabs/chat/useMessageType";
import {ref} from "vue";


const __default__ = {
    name: "ChatMessageTypeSticker"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useMessageTypeProps()
},
  emits: ["height-increase"],
  setup(__props, { emit: __emit }) {

let props = __props;

let emits = __emit;

let sticker = ref<HTMLImageElement>();


function onStickerLoad() {
    emits("height-increase", sticker.value.offsetHeight);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      ref_key: "sticker",
      ref: sticker,
      class: "sticker",
      src: _ctx.message.stickerUrl,
      onLoad: onStickerLoad
    }, null, 40, _hoisted_2),
    (_ctx.$slots.reactions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "reactions")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})